import {Component, Input, OnInit} from '@angular/core';
import {PhotoService} from './photo.service';
import * as OT from '@opentok/client';

@Component({
  selector: 'app-photo',
  templateUrl: './photo.component.html',
  styleUrls: ['./photo.component.css']
})
export class PhotoComponent implements OnInit {

  @Input()
  referenceSinistre: string;
  @Input()
  session: OT.Session;

  contactIsAskingForAPicture = false;
  popinAskingPictureTitle = 'Demande de prise de photo de la part de votre contact';
  popinAskingPictureText = 'Votre interlocuteur souhaite prendre une photo. Acceptez-vous?';

  constructor(private photoService: PhotoService) {
  }

  ngOnInit() {
    console.log('Initialisation de la session : ' + this.session.sessionId);
    this.session.on('signal:DemandePhoto', () => this.askPermissionForPicture());
  }

  async onPictureTaken(image) {
    this.contactIsAskingForAPicture = false;
    this.photoService.readImage(image.target.files[0]).then(imageLu => {
      this.photoService.sendToWebExpert(
        {
          dossierNumber: this.referenceSinistre,
          imageHQ: (imageLu as string).split(',')[1]
        })
        .subscribe((sucess) => {
            console.log('image envoyée avec succes vers webExpert');
          },
          (error) => {
            console.error('Erreur lors de l\'envoi de la photo vers WebExpert');
          });
    });
  }

  askPermissionForPicture() {
    console.log('askPermissionForPicture');
    this.contactIsAskingForAPicture = true;
  }

  userAcceptTakingPicture() {
    console.log('Tentative d\'ouverture de l\'input photo');
    document.getElementById('file-input').click();
  }

  userRefuseTakingPicture() {
    console.log('userRefuse');
  }

  onUserClickingPopin() {
    this.contactIsAskingForAPicture = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/photo/photo.component.ts